import { render } from "./InterestFilters.vue?vue&type=template&id=5a191970&ts=true"
import script from "./InterestFilters.vue?vue&type=script&lang=ts"
export * from "./InterestFilters.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/jobployee-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__